module.exports = {
      id: "cross-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.91580017.svg#cross-usage",
      toString: function () {
        return this.url;
      }
    }